<script setup lang="ts">
import { onBeforeUnmount, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '../stores/auth';

const router = useRouter();
const auth = useAuthStore();

function onState(event: Event) {
  const detail = (event as CustomEvent).detail || {};
  if (detail.user !== undefined) auth.applyUser(detail.user);
  if (typeof detail.authenticated === 'boolean') auth.authenticated = detail.authenticated;
  if (typeof detail.online === 'boolean') auth.online = detail.online;
}
async function logout() { await auth.logout(); await router.push('/'); }

onMounted(() => window.addEventListener('mindplace:auth-state', onState));
onBeforeUnmount(() => window.removeEventListener('mindplace:auth-state', onState));
</script>

<template>
  <div class="auth-header" aria-label="Cuenta de MindPlace">
    <template v-if="auth.authenticated">
      <button type="button" class="account-pill" @click="router.push('/perfil')"><span class="dot"></span>{{ auth.displayName }}</button>
      <button type="button" @click="router.push('/notificaciones')">🔔 Notificaciones</button>
      <button v-if="auth.user?.role === 'admin'" type="button" @click="router.push('/admin')">🛠 Administración</button>
      <button type="button" @click="router.push('/perfil')">Perfil</button>
      <button type="button" @click="logout">Salir</button>
    </template>
    <template v-else>
      <button type="button" @click="router.push('/login')">Iniciar sesión</button>
      <button type="button" @click="router.push('/registro')">Crear cuenta</button>
    </template>
  </div>
</template>

<style scoped>
.auth-header{position:fixed;left:20px;top:92px;z-index:12000;display:flex;flex-direction:column;gap:7px;align-items:stretch;font:600 13px/1 system-ui,sans-serif}.auth-header button{border:1px solid rgba(255,255,255,.16);border-radius:999px;padding:.5rem .75rem;background:rgba(11,17,32,.9);backdrop-filter:blur(8px);color:#eef4fb;cursor:pointer;white-space:nowrap}.auth-header button:hover{background:rgba(28,41,61,.96)}.account-pill{display:flex;align-items:center;gap:7px}.dot{width:7px;height:7px;border-radius:50%;background:#6fd5aa}@media(max-width:600px){.auth-header{left:10px;top:82px;right:auto;bottom:auto;align-items:stretch}.auth-header button{font-size:12px}}
</style>
